export { default as EN } from "./en.json";
export const RIDE_PROVIDERS_NAMESPACE = "ride-providers";
